import { get } from "lodash";

import { ITooltipParams, ValueGetterParams } from "ag-grid-community";

const PIC_DELIMITER = "|";

const getPics = ({
  data,
  colDef,
}: ValueGetterParams | ITooltipParams): string[] => {
  const field = colDef && "field" in colDef ? colDef.field : undefined;
  if (!data || !field) return [];
  const value: string = get(data, field);
  if (!value) return [];
  return value.split(PIC_DELIMITER).filter(Boolean);
};

export const sideLoadedPicsValueGetter = (params: ValueGetterParams): string =>
  getPics(params).join(", ");

export const sideLoadedPicsTooltipValueGetter = (
  params: ITooltipParams,
): string => getPics(params).join(", ");
